export default __webpack_public_path__ + "static/media/search_filter_icon.9ee12663.svg";